import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { ITEMS_SCHEMA, asItems } from "./useMagicAction";


const SuggestEmojis = (props) => {

    const { run, input, writeBackInsert, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: `Suggest 3 distinct emojis that fit the following text. Do not repeat emojis.\n\nTEXT:\n${input}`,
            schema: ITEMS_SCHEMA("A single emoji"),
        })
            .then((r) => {
                const text = asItems(r).join("");
                if (text) writeBackInsert(` ${text}`);
            })
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex flex-col items-center justify-center gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default SuggestEmojis;
